import { Text } from "./styled"

export default function MyWalletLogo() {
    return (
        <Text>MyWallet</Text>
    )
}